import { useLazyQuery, useQuery } from "@apollo/client";
import { SIGNATURES } from "../signature.queries";
import { SignaturesQuery, SignaturesQueryVariables } from "../../../__generated__/SignaturesQuery";

export const useSignatures = (variables: SignaturesQueryVariables) => {
  return useQuery<SignaturesQuery, SignaturesQueryVariables>(SIGNATURES, { variables });
};

export const useLazySignatures = () => {
  return useLazyQuery<SignaturesQuery, SignaturesQueryVariables>(SIGNATURES);
};
